import { useLocation } from 'react-router';

/**
 * Retrieve the last table page index from router state and return it as zero-based.
 *
 * Detail routes store the page index as a 1-based number so URLs display `page=1`
 * for the first page. This hook normalizes the value back to zero-based indexing
 * and always returns a non-negative number to simplify consumers.
 */
export function useFromPageState(): number {
  const location = useLocation();
  const state = location.state as { fromPage?: number } | null;
  const fromPage = state?.fromPage;

  if (typeof fromPage !== 'number') {
    return 0;
  }

  const normalized = fromPage - 1;

  return Number.isFinite(normalized) && normalized >= 0 ? normalized : 0;
}
